// extracted by mini-css-extract-plugin
export default {"container":"_3anCt","containerInner":"ba8GT","containerInnerLeft":"_1mPuq","containerInnerLeftTitle":"_1Cg9o","containerInnerLeftContent":"_39HeN","containerInnerRight":"_2lVNJ"};